import type { ClassNameProps, StyleProps } from '@root/shared/react'

type ListItemIndicatorProps = { color: string } & ClassNameProps & StyleProps
export const ListItemIndicator: React.FC<ListItemIndicatorProps> = ({
  className,
  style,
  color,
}) => {
  return (
    <svg
      width="3"
      height="32"
      viewBox="0 0 3 32"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M0 0L1.2188 0.812534C2.3316 1.5544 3 2.80332 3 4.14074V27.8593C3 29.1967 2.3316 30.4456 1.2188 31.1875L0 32V0Z"
        fill={color}
      />
    </svg>
  )
}
